import { withStyles } from "@material-ui/core";
import * as React from "react";
import { Route, Switch } from "react-router-dom";
import { compose, setDisplayName } from "recompose";
import { Download, Leave, NotFound, Register, RegisterVerification, Reset, ResetVerification, AdminRegisterVerification, AuthenticateWithProvider } from "routes";
import { styles } from "./App.styles";
import linesSvg from "assets/lines.svg";
export var Render = function (_a) {
    var classes = _a.classes;
    return React.createElement("div", { className: classes.root + ' auth-container' },
        React.createElement("img", { src: linesSvg, alt: "", style: {
                position: "absolute",
                left: "10%",
                top: "30%",
                width: "175%",
                height: "auto",
                pointerEvents: "none",
                zIndex: 0
            } }),
        React.createElement(Switch, null,
            React.createElement(Route, { exact: true, path: "/", component: Download }),
            React.createElement(Route, { exact: true, path: "/leave", component: Leave }),
            window.env.ENABLE_REGISTRATION === "true" && React.createElement(Route, { exact: true, path: "/register", component: Register }),
            window.env.ENABLE_REGISTRATION === "true" && React.createElement(Route, { path: "/register/:code+", component: RegisterVerification }),
            React.createElement(Route, { exact: true, path: "/download", component: Download }),
            React.createElement(Route, { exact: true, path: "/authorize", component: AuthenticateWithProvider }),
            React.createElement(Route, { exact: true, path: "/reset", component: Reset }),
            React.createElement(Route, { path: "/reset/:code+", component: ResetVerification }),
            window.env.ENABLE_ADMINREGISTRATION === "true" && React.createElement(Route, { path: "/adminregister/:code+", component: AdminRegisterVerification }),
            React.createElement(Route, { component: NotFound })));
};
export function enhance() {
    return compose(withStyles(styles), setDisplayName("App"));
}
export var App = enhance()(Render);
